import useVesting from "hooks/useVesting";

const useHoneyInJars = () => {
  const { vestingAmountInJarsRemaining } = useVesting();
  return vestingAmountInJarsRemaining;
};

export default useHoneyInJars;
